export default function LoadSpinner() {
    return (
        <div className="animate-spin">
            <svg
                width="40"
                height="40"
                viewBox="0 0 158 158"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M158 79.0001C158 89.3745 155.957 99.6474 151.986 109.232C148.016 118.817 142.197 127.526 134.861 134.862L116.524 116.524C121.452 111.597 125.361 105.746 128.028 99.308C130.695 92.8696 132.067 85.969 132.067 79.0001H158Z"
                    fill="white"
                />
                <path
                    d="M158 79.0001C158 60.7231 151.663 43.0114 140.068 28.8831C128.473 14.7547 112.338 5.08377 94.4122 1.51809C76.4863 -2.04759 57.8786 0.712595 41.7597 9.32834C25.6407 17.9441 13.0079 31.8823 6.01354 48.7681C-0.980793 65.6539 -1.90382 84.4425 3.40173 101.933C8.70728 119.423 19.9131 134.532 35.11 144.686C50.3068 154.84 68.5543 159.411 86.7434 157.62C104.932 155.828 121.938 147.785 134.861 134.862L116.524 116.524C107.843 125.206 96.4197 130.608 84.2015 131.812C71.9833 133.015 59.7258 129.945 49.5175 123.124C39.3093 116.303 31.7819 106.153 28.2179 94.4047C24.654 82.656 25.2741 70.035 29.9724 58.6922C34.6707 47.3494 43.1567 37.9866 53.9844 32.1991C64.812 26.4116 77.3115 24.5575 89.3529 26.9527C101.394 29.3479 112.233 35.8442 120.021 45.3347C127.81 54.8252 132.067 66.7228 132.067 79.0001H158Z"
                    fill="#D9D9D9"
                    fillOpacity="0.42"
                />
            </svg>
        </div>
    );
}
